import { Button, styled } from "@mui/material"
import Container from "@mui/material/Container"
import { captureMessage } from "@sentry/react"
import {
  ErrorBoundary as ErrorBoundaryBase,
  type FallbackProps,
  getErrorMessage,
} from "react-error-boundary"
import { IS_DEV, IS_LOCAL } from "../../../../common/src/constants"

const MessageContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(2),
  border: `1px solid ${theme.palette.error.main}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.error.light,
  width: "fit-content",
}))

const BoundaryContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
})

const FallbackComponent: React.FC<FallbackProps> = ({ error }) => {
  captureMessage("Error caught by ErrorBoundary", {
    level: "error",
    extra: {
      error: error,
    },
  })
  console.error(error)
  return (
    <BoundaryContainer>
      <MessageContainer>
        <p>Sorry, something went wrong. Please contact support for help.</p>
        {IS_DEV || IS_LOCAL ? (
          <div>
            <pre>{getErrorMessage(error)}</pre>
          </div>
        ) : null}
      </MessageContainer>
      <Button
        sx={{
          margin: 2,
        }}
        onClick={() => window.location.reload()}
        variant="contained"
      >
        Reload Page
      </Button>
    </BoundaryContainer>
  )
}

export const ErrorBoundary: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <ErrorBoundaryBase FallbackComponent={FallbackComponent}>
      {children}
    </ErrorBoundaryBase>
  )
}
